<template>
  <Navbar v-if="lang=='fa' && path!='/sign-in' && path!='/sign-up'&&path!='/test'&&path!='/dashboard'&&path!='/sign-in-signals'&&path!='/online-signals'"/>
  <EnNavbar v-if="lang=='en' && path!='/sign-in' && path!='/sign-up'&&path!='/test'&&path!='/dashboard'&&path!='/sign-in-signals'&&path!='/online-signals'"/>
  <router-view/>
  <Footer v-if="lang=='fa' && path!='/online-signals' && path!='/sign-in' && path!='/sign-up'&& path!='/test'&&path!='/dashboard'&&path!='/online-signals'&&path!='/sign-in-signals'" />
  <EnFooter v-if="lang=='en' && path!='/online-signals' && path!='/sign-in' && path!='/sign-up'&& path!='/test'&&path!='/dashboard'&&path!='/online-signals'&&path!='/sign-in-signals'" />
</template>

<script lang="ts">
import Navbar from './views/navbar.vue';
import EnNavbar from './views/en/navbar-en.vue';
import Footer from './views/footer.vue';
import EnFooter from './views/en/footer-en.vue';
import { defineComponent, ref, watch } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {Navbar,Footer,EnFooter,EnNavbar},
  setup(){
    const router = useRouter()
    const path = ref()
    const lang = localStorage.getItem('lang') ? ref(localStorage.getItem('lang')):ref('fa')
    

    watch(router.currentRoute,()=>{
      path.value = window.location.pathname;
      if (window.location.pathname.startsWith('/online-signals/')) {
        path.value = '/online-signals'
      }
      if (window.location.pathname.startsWith('/dashboard/')) {
        path.value = '/dashboard'
      }
      if (router.currentRoute.value.name=='dashboard') {
        if (!localStorage.getItem('phone')) {
          router.push({'name':'sign-in'})
        }
      }
      if (router.currentRoute.value.path=='/online-signals') {
        if (!localStorage.getItem('phone')) {
          router.push({'name':'sign-in-signals'})
        }
      }
    })

    return{
      router,
      path,
      lang
    }
  }

})
</script>

<style>
@import url('./assets/scss/style.scss');
#app {
  font-family: iransans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
